import { toast } from "react-toastify";
import { create } from "zustand";
import { devtools } from "zustand/middleware";
import { api } from "../helpers/api";
import axios from "axios";

const useTransaction = create(
  devtools((set) => ({
    transactions: [],
    lastTransactions: [],
    savedReportList: [],
    savedReportListMeta: {},
    viewTransactionWithoutData: {},
    viewTransactionWithoutDataForCommission: {},
    viewTransactionRWithoutData: [],
    loading: false,
    lastTransactionsLoading: false,
    savedReportListLoading: false,
    savedReportSaveLoading: false,
    viewTransactionWithoutDataMessage: null,
    viewTransactionRWithoutLoading: false,
    editTransactionLoading: false,
    message: null,
    success: false,
    modal: false,
    savedReportSaveSuccess: false,
    viewTransactionWithoutForCommissionLoading: false,
    // Transaction
    fetchTransactions: async (params) => {
      try {
        set({ loading: true, message: null });
        const { data } = await api.get(`/client/transaction-list`, { params });
        set({
          transactions: await data,
        });
      } catch (err) {
        return err;
      } finally {
        set({ loading: false, message: null });
      }
    },
    fetchLastTransactions: async () => {
      try {
        set({ lastTransactionsLoading: true, message: null });
        // const response = await api.post(`/transaction/last`);
        const response = await api.get(
          `/client/transaction-list?page=1&limit=5`
        );
        set({
          lastTransactions: await response?.data?.data,
          lastTransactionsLoading: false,
        });
      } catch (err) {
        set({
          message: "Error",
          lastTransactionsLoading: false,
        });
      } finally {
        set({ lastTransactionsLoading: false });
      }
    },
    fetchSavedReports: async (params) => {
      set({ savedReportListLoading: true, message: null });
      try {
        const { data } = await api.get(`/client/saved-reports`, { params });
        set({
          savedReportList: data?.data,
          savedReportListMeta: data?.pagination,
        });
      } catch (err) {
        return err;
      } finally {
        set({
          savedReportListLoading: false,
          savedReportSaveSuccess: false,
        });
      }
    },
    savedReportSave: async (params) => {
      set({ savedReportSaveLoading: true, message: null });
      const response = await api.post("/client/saved-reports", params);
      const success = await response?.data?.success;
      const message = await response?.data?.message;
      const errorMessage = await response?.data?.error?.message;
      set({
        savedReportSaveLoading: false,
        savedReportSaveSuccess: success,
      });
      set({
        message: "Error",
        savedReportSaveLoading: false,
        savedReportSaveSuccess: success,
      });
      if (success) {
        toast.success("Успешно создано");
        set({ modal: false });
      }
      if (!success) {
        toast.error(message || errorMessage);
      }
    },
    fetchDetailSavedReports: async (id) => {
      const { data } = await api.get(`/admin/saved-report/${id}`);
      const success = await data?.success;
      if (success && data?.data?.status?.int !== 0) {
        set((state) => ({
          savedReportList: state.savedReportList?.filter(
            (item) => +item?.id !== +id
          ),
        }));
        set((state) => ({
          savedReportList: [data?.data, ...state.savedReportList],
        }));
      }
    },
    fetchDetailTransactionRWithoutToken: async (params) => {
      set({
        viewTransactionRWithoutLoading: true,
      });
      const response = await api.post("/get-chequeue-details", params);
      set({
        viewTransactionRWithoutData: response?.data,
        viewTransactionRWithoutLoading: false,
      });
    },
    editTransaction: async (id, params) => {
      set({ editTransactionLoading: true });
      try {
        const response = await api.put(
          `client/transaction-update/${id}`,
          params,
          {
            timeout: 60000,
          }
        );
        set({ editTransactionLoading: false });
        return response;
      } catch (error) {
        set({ editTransactionLoading: false });
        if (axios.isAxiosError(error) && error.code === "ECONNABORTED") {
          toast.error(
            "Запрос не получил ответа. Пожалуйста, попробуйте еще раз!"
          );
        }
      } finally {
        set({ editTransactionLoading: false });
      }
    },
    downloadFile: async (params) => {
      set({ downloadFileLoading: true });
      try {
        const { data } = await api.get(`/download-saved-report`, {
          params,
          responseType: "blob",
        });
        return data;
      } catch (err) {
        toast.error("Yuklashda xatolik");
        return err;
      } finally {
        set({ downloadFileLoading: false });
      }
    },
    openModal: () => {
      set({ modal: true });
    },
    closeModal: () => {
      set({ modal: false });
    },
  }))
);

export default useTransaction;
